import {useEffect} from "react";

import IconBool from "components/IconBool";
import translations from "./translations";
import useCustomTranslation from "core/customTranslation";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import ManagerDataTable from "./models/table/MangerDataTable";

const TableAlerts = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tc} = useCustomTranslation(translations);

    useEffect(() => {
        if (itemsShow.length) {
            let numLabels = 0;
            itemsShow.forEach((item) => {
                if (Object.keys(item.has).length > numLabels) numLabels = Object.keys(item.has).length;
            });
        }
    }, [itemsShow]);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "32px",
                            verticalAlign: "bottom",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                    <th style={{width: "90px", ...stickyHeaderStyle}} className="text-center sticky-top border-bottom-sticky">
                        {_Tc("fields.no_send.short")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle, textAlign: "center"}}
                        className="text-center sticky-top border-bottom-sticky">
                        {_Tc("params")}
                    </th>
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.length > 0 ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onChange={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxOpModes"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={items.current.chosen.includes(item.id)}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>{item.model}</td>
                            <td className="text-center">
                                <IconBool value={item.has_not_send} />
                                <span className="ms-2">{item.days}</span>
                            </td>
                            <td>
                                <ManagerDataTable item={item} _TC={_Tc} />
                            </td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableAlerts;
